import { Toast } from "vant";
  // 打包前看readme文件
export const mixins = {
  data() {
    return {
      urlList: [
        { time: 0, name: '91porn', url: 'https://d11mj6p2thi2vw.cloudfront.net'},
        { time: 0, name: '逼哩逼哩', url: 'https://d2abfw20zg31a.cloudfront.net'},
        { time: 0, name: '海角乱伦', url: 'https://d2cc5gnpgq5u8h.cloudfront.net', webUrl: 'https://doyj68zud8dgm.cloudfront.net' },
        { time: 0, name: '91原创', url: 'https://d24huswlob3me8.cloudfront.net' },
        { time: 0, name: '好色', url: 'https://d1f1wgvqrzh80g.cloudfront.net', webUrl: 'https://d39cmeitkp3imu.cloudfront.net' },
        { time: 0, name: '快手视频', url: 'https://d13hcc42jp6141.cloudfront.net'},
        { time: 0, name: '萝莉岛', url: 'https://d3hazbgk7dtwpj.cloudfront.net', webUrl: 'https://d1q6v0m0fmxvl0.cloudfront.net' },
        { time: 0, name: '91暗网', url: 'https://d1h0kcl57yrnyf.cloudfront.net', webUrl: 'https://dh0n7f6bcnjxj.cloudfront.net' },

        { time: 0, name: 'Pomhub专业版', url: 'https://d1y9ws6txjyjlq.cloudfront.net' },
        { time: 0, name: '快手视频', url: 'https://d13hcc42jp6141.cloudfront.net' },
        { time: 0, name: '萝莉岛', url: 'https://d2lsern5axmn0y.cloudfront.net' },
        { time: 0, name: '妻友', url: 'https://d31xon7cnqlx3n.cloudfront.net' },
        { time: 0, name: '91原创', url: 'https://d24huswlob3me8.cloudfront.net' },
        { time: 0, name: 'Pornhub中文版', url: 'https://dsa2orgtbxyp7.cloudfront.net/' },
        { time: 0, name: 'XV暗网', url: 'https://d31r9a0t489y7k.cloudfront.net/' },
        { time: 0, name: '稚青社', url: 'https://dpm8zwr1hoak6.cloudfront.net/' },
      ],
      ping: 1,
      timer: null,
      showImg: true,
      addressUrl: "cao.gg",
    };
  },
  mounted() {
    this.addressUrl = window.location.host;
    this.$nextTick(() => {
      this.init();
    });
  },
  methods: {
    init() {
      this.timer = setInterval(() => {
        this.ping++;
      }, 100);
    },
    autoTest(item, index) {
      if (this.ping <= 10) {
        item.time = this.ping * 10;
      } else {
        item.time = this.ping * 100;
      }
      if (index == this.urlList.length - 1) {
        clearInterval(this.timer);
      }
    },
    jumpUrl(url) {
      const routeDc = this.$route.query.dc
      if (routeDc) {
        window.open(url + '?dc=' + routeDc);
      } else {
        const dc = process.env.VUE_APP_WEB_DC || 'lqz01'
        window.open(url + '?dc=' + dc);
      }
    },
    reset() {
      this.urlList = this.urlList.map((item) => {
        item.time = 0;
        return item;
      });
      this.showImg = false;
      this.$nextTick(() => {
        this.showImg = true;
      });
      this.ping = 1;
      this.init();
    },
    doCopy() {
      let req = this.addressUrl;
      this.$copyText(req).then(
        () => {
          Toast("复制成功");
        },
        () => {
          Toast("复制失败");
        }
      );
    },
  },
};
